import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../axios';

const initialState = {
	notificationSettings: { loading: false, data: null },
	intervals: { loading: false, data: [] },
};

export const getNotificationIntervals = createAsyncThunk(
	'NotificationSettings/getIntervals',
	async () => {
		try {
			const response = await axios.get('/notification-settings/intervals');
			return response.data;
		} catch (error) {
			const customError = {
				name: 'Custom axios error',
				message: error.response?.data?.message || error.message,
			};
			throw customError;
		}
	},
);

export const getNotificationSettings = createAsyncThunk(
	'NotificationSettings/getSettings',
	async () => {
		try {
			const response = await axios.get('/notification-settings');
			return response.data;
		} catch (error) {
			const customError = {
				name: 'Custom axios error',
				message: error.response?.data?.message || error.message,
			};
			throw customError;
		}
	},
);

export const updateNotificationSettings = createAsyncThunk(
	'NotificationSettings/updateSettings',
	async (settings) => {
		try {
			const response = await axios.put('/notification-settings', settings);
			return response.data;
		} catch (error) {
			const customError = {
				name: 'Custom axios error',
				message: error.response?.data?.message || error.message,
			};
			throw customError;
		}
	},
);

export const deleteNotificationSettings = createAsyncThunk(
	'NotificationSettings/deleteSettings',
	async () => {
		try {
			await axios.delete('/notification-settings');
			return null;
		} catch (error) {
			const customError = {
				name: 'Custom axios error',
				message: error.response?.data?.message || error.message,
			};
			throw customError;
		}
	},
);

const notificationSettingsSlice = createSlice({
	name: 'NotificationSettings',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getNotificationIntervals.pending, (state) => {
				state.intervals.loading = true;
			})
			.addCase(getNotificationIntervals.rejected, (state) => {
				state.intervals.loading = false;
			})
			.addCase(getNotificationIntervals.fulfilled, (state, action) => {
				state.intervals.loading = false;
				state.intervals.data = action.payload;
			})
			.addCase(getNotificationSettings.pending, (state) => {
				state.notificationSettings.loading = true;
			})
			.addCase(getNotificationSettings.rejected, (state) => {
				state.notificationSettings.loading = false;
			})
			.addCase(getNotificationSettings.fulfilled, (state, action) => {
				state.notificationSettings.loading = false;
				state.notificationSettings.data = action.payload;
			})
			.addCase(updateNotificationSettings.pending, (state) => {
				state.notificationSettings.loading = true;
			})
			.addCase(updateNotificationSettings.rejected, (state) => {
				state.notificationSettings.loading = false;
			})
			.addCase(updateNotificationSettings.fulfilled, (state, action) => {
				state.notificationSettings.loading = false;
				state.notificationSettings.data = action.payload;
			})
			.addCase(deleteNotificationSettings.fulfilled, (state) => {
				state.notificationSettings.data = null;
			});
	},
});

export default notificationSettingsSlice.reducer;
